import { Component, Input } from '@angular/core';

/**
 * Inline notice for forms and dialogs: an icon and a short message in an amber (warning) or
 * red (error) box. Spacing around it is left to the parent.
 *
 *   <app-form-warning>Make sure channel is in the configuration assigned to the displays.</app-form-warning>
 *   <app-form-warning variant="error">Select at least one active day.</app-form-warning>
 */
@Component({
  selector: 'app-form-warning',
  templateUrl: './form-warning.component.html',
  styleUrls: ['./form-warning.component.scss'],
  standalone: false,
  host: {
    'class': 'form-warning',
    '[class.form-warning--error]': "variant === 'error'"
  }
})
export class FormWarningComponent {
  @Input() variant: 'warning' | 'error' = 'warning';
  /** Material icon name; defaults to warning_amber or error_outline */
  @Input() icon: string | null = null;

  get iconName(): string {
    return this.icon ?? (this.variant === 'error' ? 'error_outline' : 'warning_amber');
  }
}
